
import riskModule from '~/components/common/riskModuleFxeye.vue'
export default {
  name: 'WikiCommon',
  components: {
    'risk-module': riskModule
  },
  data() {
    return {
      urlpath: this.$route.fullPath
    }
  },
  head() {
    // 不显示hreflang页面-资讯详情页、教育文章详情页、百科详情页、交易商介绍详情页
    const show = this.$route.name == 'lang-newsdetail-id' || this.$route.name == 'lang-learn-id' || this.$route.name == 'lang-wikishow-id' || this.$route.name == 'lang-intro-id' || this.$route.name == 'lang-exposure-add.html'
    const canonicalshow = this.$route.name == 'lang-exposure-add.html'
    let ate = []
    let canonicalarr = []
    if (!show) {
      ate = [...this.alternate()]
    }
    if (!canonicalshow) canonicalarr = [...this.canonical()]

    let googleurl = ''
    if (this.$store.state.isWiki == '1') {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172151915-1'
    } else if (this.$store.state.isWiki == '3') {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172151915-10'
    } else if (this.$store.state.isWiki == '2' || this.$store.state.isWiki == '4') {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172113747-5'
    }
    const icon = this.$store.state.isWiki == '1' || this.$store.state.isWiki == '3' ? 'https://resources1.interface003.com/web20/img/favicon-wikifx.ico' : 'https://resources1.interface003.com/web20/img/favicon-fxeye.ico'
    if (this.urlpath.includes('login2.html')) googleurl = ''
    return {
      htmlAttrs: {
        lang: this.$route.params.lang,
        dir: this.$route.params.lang == 'ar' ? 'rtl' : 'ltr'
      },
      // title: '\u200F' + 'title',
      link: [...ate, ...canonicalarr, { rel: 'icon', type: 'image/x-icon', href: icon }],
      script: [
        {
          charset: 'utf-8',
          src: googleurl,
          body: false,
          async: true
        }
      ]
    }
  }
}
